import { render, staticRenderFns } from "./NormalSearchNav201.vue?vue&type=template&id=56d96b02&scoped=true"
import script from "./NormalSearchNav201.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav201.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d96b02",
  null
  
)

export default component.exports